module.exports = __webpack_public_path__ + "img/idx-game-sports.685b0cb.webp";